// extracted by mini-css-extract-plugin
export var createdDate = "_lr-1";
export var divider = "_lr-2";
export var headerDivider = "_lr-3";
export var messagesCard = "_lr-0";
export var messagesContainer = "_lr-7";
export var messagesContainerWrapper = "_lr-4";
export var pointerCapturingButtonBoxes = "_lr-a";
export var showLeftPanelButton = "_lr-9";
export var showMoreButton = "_lr-c";
export var showMoreButtonContainer = "_lr-b";
export var summaryTitle = "_lr-6";
export var systemMessageCardWrapper = "_lr-d";
export var topButtons = "_lr-8";
export var withPadding = "_lr-5";